import { CreateView, LoggerFactory, withBreadCrumbs } from "lego-gui-lib";
import { FieldSetsForm } from "lego-gui-lib/lib/components/Views/ShowView/FieldSetsForm";
import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { SanContext, SANSchema } from "./schema";
import { mainStore } from "../../core/mainStore";
import { useHistory, useRouteMatch } from "react-router";
import { useTranslation } from "react-i18next";

const log = LoggerFactory.create("CreateSAN");

const createSchema = SANSchema.extend(
  {
    customerRef: {},
    mainNumber: {},
    blocked: {},
    serviceProfileRef: {
      onChange: (nv: any, ov: any, formState) => {
        const serviceProfile = mainStore.serviceProfileFK.listDataSource.list.find(
          (sp: any) => sp.id === nv
        );

        log.debug("selected service profile", nv, serviceProfile);

        formState.values["serviceProfile"] = serviceProfile;
      }
    },
    billingSanType: {},
    billingSystem: {},
    languageRef: {},
    routingType: {},
    translatedDestination: {},
    msgRoutingRef: {},
    presentation: {}
  },
  { onlyGiven: true }
);

export const Create = observer(({ ...rest }: any) => {
  const SAN = useContext(SanContext);
  const match = useRouteMatch();
  const history = useHistory();

  const { t } = useTranslation();
  const title = t("common:create", { domain: "hns:san:domain" });

  return withBreadCrumbs(
    { to: match.url, children: title },
    <CreateView
      dataSource={SAN.oneDataSource}
      Presentation={FieldSetsForm}
      {...rest}
      title={title}
      fields={createSchema}
      id={match.params}
      initialValues={{
        presentation: 0,
        smsNotifActive: 0
      }}
      goBack={() => history.goBack()}
    />
  );
});

export const Clone = observer(({ ...rest }: any) => {
  const SAN = useContext(SanContext);
  const match = useRouteMatch();
  const history = useHistory();

  const { t } = useTranslation();
  const title = t("common:create", {
    domain: "hns:san:domain"
  });

  return withBreadCrumbs(
    { to: match.url + "/edit", children: t("common:copy") },
    <CreateView
      submit={async () => {
        return SAN.oneDataSource.clone();
      }}
      dataSource={SAN.oneDataSource}
      {...rest}
      title={title}
      fields={createSchema}
      id={match.params}
      goBack={() => history.goBack()}
    />
  );
});
